export { FocusTrap } from "@mantine/core";
export type { FocusTrapProps } from "@mantine/core";
